import { styled } from "@mui/system";

export const PendenciesStepRoot = styled("div")`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 12px;
    max-width: 1024px;
    margin: auto;
    
     

    @media only screen and (max-width: 600px) {
        max-width: 384px;
        
        
        .dasReport {
  
            max-width: 384px;
            padding: 0.5rem 0.5rem;
        }

        .dasItem {
  
            max-width: 100%;
            padding: 0.5rem 0.5rem;
        }
    }

    & .finish {
        width: fit-content;
        margin-left: auto;
    }
    & .link {
        display: flex;
        flex-direction: column;
        width: fit-content;
        margin: 0 auto;
        justify-content: center;
        align-items: center;
        padding: 12px;
        border-radius: 4px;
        transition: 0.2s;
        text-decoration: none;
        :hover {
            opacity: 0.8;
        }
    }
    
    & .link-error {
        background-color: #a84161;
    }

    & .link-success {
        background-color: #1254e2;
    }

    & .sendBtn {
        display: flex;
        flex-direction: column;
        border: solid 2px #8403c5;
        border-radius: 5%;
        background-color: #7801b4;
        width: fit-content;
        margin: 0 auto;
        margin-top: 1.5rem;
        justify-content: center;
        align-items: center;
        padding: 12px;
        border-radius: 4px;
        transition: 0.2s;
        text-decoration: none;
        :hover {
            opacity: 0.8;
        }
    }


    & .dasReport {
        display: flex;
        flex-direction:  column;
        text-align: center;
        margin-top: 1.5rem;
        max-height: 1000px;
         
        overflow-y: scroll;
        scrollbar-width: thin;
        scrollbar-color: #8702c9 #6B00A1 ;
        width: fit-content;
        margin: auto;
         

        
        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
            width: 4px;
        }

        *::-webkit-scrollbar-track {
            background: #6B00A1;
        }

        *::-webkit-scrollbar-thumb {
            background-color: #6B00A1;
            border-radius: 4px;
            border: 3px groove #ffffff;
        }
                

    }

    & .dasItem {
         
        
        margin: 1.55rem auto;
         & .downloadBtn{
            display: flex;
            justify-content: end;
         }

    }


    & .consultDasBtn {
        border: solid 1px white;
        background-color: #ADEFD1;
        font-weight: 500;
        font-size: large;
        color: #000305;
        border-radius: 5px;
        padding: 24px;
        width: fit-content;
        margin: 0 auto;
        animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;

        animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;

        @keyframes pulse {
            0%, 100% {
                
                background-color: #fdff78;
            }
            50% {
                background-color: #e7eb00;
                 
            }
        }
        :hover {
            opacity: 0.8;
        }
    }

    `;
    

export const PendenciesSummary = styled("div")`
    display: flex;
    flex-direction: column;
    gap: 24px;

 

    & .summary {
        background-color: rgba(255, 255, 255, 0.05);
        background-color: transparent;
        margin: auto;
        padding: 12px 8px 24px 8px;
        width: 80%;
    }

    & .posCons {
        display: flex;
        gap: 12px;
        padding: 12px 48px;
    }

    & .list {
        width: 100%;

        & .MuiPaper-root {
            background-color: unset;
            border-bottom: 0;
            box-shadow: unset;
        }
    }

    & .list-title {
        padding: 12px;
        background-color: rgba(255, 255, 255, 0.1);
        background-color: transparent;
    }
`;

export const PendenciesYears = styled("div")`
    display: flex;
    flex-direction: column;
    padding: 12px;
    
    & .accordion {
        background-color: rgba(255, 255, 255, 0.05);
    }

    & .css-rorn0c-MuiTableContainer-root {
        display: flex;
        flex-direction: column;
        overflow: initial;

    }

    & .MuiTableCell-root {
        border-bottom: unset;
    }

    & .MuiTableHead-root {
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 0.05);
    }
    
    & .MuiTableRow-root {
        :nth-child(even) {
            background-color: rgba(255, 255, 255, 0.05);
        }
    }
`;

export default PendenciesStepRoot;

